import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "../../../App";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { hireCandidate } from "../../../store/actions/Jobs/jobActions";
import { Badge, Form } from "react-bootstrap";
import { get, post } from "../../../services/api";
import swal from "sweetalert";
import Select from "react-select";
import { loginRequest } from "../../../authConfig";
import moment from "moment";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { isPastDate } from "../../../utils/date";

const Candidates = ({
  token,
  candidates,
  selectedRequirement,
  setShowAssignCandidateModal,
  restrictedCandidates = { restrictedCandidates },
}) => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [unselectedCandidates, setUnselectedCandidates] = useState([]);
  const filterSelectedCandidates = (selected, totalCandidates) => {
    return totalCandidates.filter((candidate) =>
      selected.some((sel) => sel.value === candidate._id)
    );
  };
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [newselectedCandidates, setNewSelectedCandidates] = useState([]);
  const [candidateStartTimes, setCandidateStartTimes] = useState({});
  const dispatch = useDispatch();
  const handleEmailAction = (action) => {
    if (isAuthenticated) {
      action();
    } else {
      swal({
        title: "Email Not Synced",
        text: "Please sync your email first.",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          sync: {
            text: "Sync Email",
            value: "sync",
          },
        },
      }).then((value) => {
        if (value === "sync") {
          instance.loginPopup(loginRequest).catch((e) => {
            console.error(e);
          });
        }
      });
    }
  };
  const getCandidateName = (id) => {
    // return candidates?.filter((itm) => itm?._id === id)?.[0]?.firstName || "--";
    return (
      candidates
        ?.filter((itm) => itm?._id === id)
        ?.map((itm) => `${itm?.firstName || "--"} ${itm?.lastName || "--"}`)?.[0] || "--"
    );
    
  };
  useEffect(() => {
    if (selectedRequirement?._id) {
      getCandidateJobList();
    }
  }, [selectedRequirement]);
  const getCandidateJobList = async () => {
    const response = await get(
      "/api/job/candidate/job/" + selectedRequirement?._id,
      token
    );
    const filteredDefault = response?.map((c) => {
      return { value: c?.candidateId, label: getCandidateName(c?.candidateId) };
    });
    setSelectedCandidates(filteredDefault);
    const filtered = candidates?.map((c) => {
      return {
        value: c?._id,
        label: c?.firstName + " " + c?.lastName,
        isDanger: (c.visaExpiry && isPastDate(c.visaExpiry)),
        isRisky:
          (c.nationality !== "United Kingdom" &&
          c.nationality !== "Ireland" &&
          c.allowedHoursPerWeek <= 37) 
      };
    });
    console.log("filtered", filtered);
    setUnselectedCandidates(filtered || []);
  };

  // Simple function to validate candidate hours
  const validateCandidateHours = async (candidatesSelected, weekStartDate, weekEndDate) => {
    try {
      // Extract candidate IDs
      const candidateIds = candidatesSelected.map(c => c._id);
      
      // Call the validation endpoint
      const response = await post(
        "/api/job/validate-candidate-hours",
        {
          candidateIds,
          jobId: selectedRequirement?._id,
          weekStartDate,
          weekEndDate
        },
        token
      );
      
      // Log the raw response for debugging
      console.log('Raw validation response:', response);
      
      // Simply return the response directly
      return response;
    } catch (error) {
      console.error("Error validating candidate hours:", error);
      swal({
        title: "Error",
        text: "Failed to validate candidate working hours. Please try again.",
        icon: "error",
      });
      return { isValid: false, results: [], exceedingCandidates: [] };
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.isRisky
        ? state.isFocused
          ? "#fff8ed"
          : "#fcefdc"
        : state.isFocused
        ? "#d3d3d3"
        : "#f0f0f0",
      color: state.data.isRisky ? "#ea8d00" : state.data.isDanger ? "rgb(255 94 94)" : "#000000",
      cursor: "pointer",
      // lineHeight: "40px",

      //       paddingLeft: " 15px",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#f0f0f0",
      // lineHeight: "40px",

      //       paddingLeft: " 15px",
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      // lineHeight: "40px",

      //       paddingLeft: " 15px",
    }),
  };

  return (
    <div className="d-flex">
      {/* Unselected Candidates */}
      <div className="candidate-panel w-50">
        <h5>Assigned Candidates</h5>
        {selectedCandidates?.map((d) => (
          // <Badge bg="info" className="me-2">
          //   {d?.label}
          // </Badge>
          <Badge bg="info" className="me-2 my-2">
          {d?.label}
          </Badge>

        ))}
        <br />
        <h5>Assign Candidates</h5>

        <Select
          value={newselectedCandidates}
          onChange={setNewSelectedCandidates}
          options={unselectedCandidates}
          isOptionDisabled={(option) =>
            selectedCandidates.some(
              (selected) => selected.value === option.value
            ) ||
            newselectedCandidates.some(
              (selected) => selected.value === option.value
            ) ||
            newselectedCandidates.length + selectedCandidates.length >=
              selectedRequirement?.quantity ||
            restrictedCandidates.some(
              (restricted) => restricted.candidateId === option.value
            )
          }
          isMulti
          isClearable={false}
          isSearchable
          // style={{
          //   lineHeight: "40px",
          //   color: "#7e7e7e",
          //   paddingLeft: " 15px",
          // }}
          styles={customStyles}
        />
        
        {newselectedCandidates.length > 0 && (
          <div className="mt-3">
            <h5>Candidate Start Times</h5>
            {newselectedCandidates.map((candidate) => (
              <Form.Group key={candidate.value} className="mb-3">
                <Form.Label>{candidate.label} - Start Time</Form.Label>
                <Form.Control
                  type="time"
                  value={candidateStartTimes[candidate.value] || "08:00"}
                  onChange={(e) => {
                    setCandidateStartTimes({
                      ...candidateStartTimes,
                      [candidate.value]: e.target.value
                    });
                  }}
                  required
                />
              </Form.Group>
            ))}
          </div>
        )}
        
        <button
          className="btn btn-sm btn-primary mt-4"
          onClick={(e) => {
            e.preventDefault();
            handleEmailAction(() => {
              const candidatesSelected = filterSelectedCandidates(
                newselectedCandidates,
                candidates
              );
              
              if (candidatesSelected.length === 0) {
                swal({
                  title: "No candidates selected",
                  text: "Please select at least one candidate to assign",
                  icon: "warning",
                });
                return;
              }
              
              const jobDate = selectedRequirement?.jobStartDate ? new Date(selectedRequirement.jobStartDate) : new Date();
              const weekStartDate = moment(jobDate).startOf('isoWeek').format('YYYY-MM-DD');
              const weekEndDate = moment(jobDate).endOf('isoWeek').format('YYYY-MM-DD');

              validateCandidateHours(candidatesSelected, weekStartDate, weekEndDate).then(response => {
                console.log('Validation response:', response);
                
                if (response.data.isValid === true) {
                  console.log('Backend says validation is valid, proceeding with assignment');
                  
                  swal({
                    title: "Are you sure?",
                    text: "We will send a booking confirmation letter to the candidate(s)!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                  }).then(async (willDelete) => {
                    if (willDelete) {
                      try {
                        const candidatesWithStartTimes = candidatesSelected.map(candidate => ({
                          ...candidate,
                          startTime: candidateStartTimes[candidate._id] || "08:00"
                        }));
                        
                        const payload = { 
                          candidates: candidatesWithStartTimes
                        };
                        
                        if (selectedRequirement?._id) {
                          if (accounts?.length > 0) {
                            try {
                              const accessToken = await instance.acquireTokenSilent({
                                ...loginRequest,
                                account: accounts[0],
                              });
                              payload.accessToken = accessToken.accessToken;
                            } catch (tokenError) {
                              console.warn("Failed to acquire token silently:", tokenError);
                            }
                          }
                          dispatch(
                            hireCandidate(payload, selectedRequirement?._id, token)
                          );
                          setShowAssignCandidateModal(false);
                        }
                      } catch (error) {
                        console.error("Error assigning candidates:", error);
                        swal("Error", "Something went wrong while assigning candidates.", "error");
                      }
                    }
                  });
                } else {
                  console.log('Backend says validation is invalid, showing error modal');
                  
                  let errorMessage = "The following candidates cannot be assigned due to working hour limits:\n\n";
                  
                  if (response.exceedingCandidates && response.exceedingCandidates.length > 0) {
                    response.exceedingCandidates.forEach(c => {
                      errorMessage += `${c.name}: `;
                      
                      if (c.allowedHours === 0) {
                        errorMessage += `Not allowed to work (0 hours)\n`;
                      } else if (c.remainingHours <= 0) {
                        errorMessage += `No remaining hours (allowed: ${c.allowedHours}h, worked: ${c.workedHours}h)\n`;
                      } else {
                        errorMessage += `Has ${c.data.remainingHours}h remaining (allowed: ${c.allowedHours}h, worked: ${c.workedHours}h)\n`;
                      }
                    });
                  }
                  
                  swal({
                    title: "Working Hours Exceeded",
                    text: errorMessage,
                    icon: "error",
                    button: "OK",
                  });
                }
              });
            });
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    candidates: state.candidates.candidates || [],
  };
};

export default withRouter(connect(mapStateToProps)(Candidates));
